import React from 'react';
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import { ReactComponent as PluginSvg } from "@assets/icons/transfer-24px.svg";
import { getLocale, defaultTarget } from '@utils/util';
import Transfer from './components/Transfer';
import TransferSettings from './components/TransferSettings';

export default () => {
  const messages = getLocale();
  return {
    name: 'transfer', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.SELECT, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages.PAGEBUIDER_ELEMENT_TRANSFER, // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      componentSettings: {
        titles: ["Source", "Target"],
        remote: {
          url: 'https://mock.iwhalecloud.com/mock/1889/transferList',
          method: 'GET',
          params: {},
        },
        autoInitialize: false,
        label: 'userName', // 穿梭框label
        key: 'id', // 穿梭框key
        selectedKeys: [], // 选择数据
        showSelectAll: false, // 是否展示全选勾选框
        showSearch: false, // 是否显示搜索框
        pagination: false, //使用分页样式，自定义渲染列表下无效
      },
      settings: {
        width: {
          value: '100%',
        },
      },
    },
    pluginComponent: Transfer, // 插件渲染组件
    pluginSettingComponent: TransferSettings, // 插件设置项组件
  };
};
